import React from "react";
import { Card, Form, Input } from "antd";
import { UserListPanel } from "./UserListPanel";
import { useLazyQuery } from "@apollo/react-hooks";
import { Rules } from "../../../common/AsyncValid";
import { userGql } from "../../../graphql/user";

export const SearchUserPanel = ({ onSelect, selectText }) => {
  const [form] = Form.useForm();

  const [findByEmail, { loading, data: { findUserByEmail } = { findUserByEmail: [] } }] = useLazyQuery<any>(
    userGql.findUserByEmail
  );

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 },
  };

  const onSearch = (val) => {
    if (val) findByEmail({ variables: { email: val } });
  };

  return (
    <Card>
      <Form form={form} {...layout} initialValues={{}}>
        <Form.Item label="Email" name="email" rules={Rules.email}>
          <Input.Search placeholder="Enter user's email" onSearch={onSearch} allowClear loading={loading} />
        </Form.Item>
      </Form>
      <UserListPanel selectText={selectText} members={findUserByEmail} onSelect={onSelect} />
    </Card>
  );
};
